import { gql } from '@apollo/client';

/**
 * Represents the widget configuration object that can be reused in queries and
 * mutations as a response fragment.
 */
const widgetConfigurationFragment = gql`
  fragment WidgetConfigurationFragment on Management_WidgetConfiguration {
    id
    type
    enabled
    name
    misconfigured
    misconfigurationCause
    additionalProperties
    settings {
      key
      value
    }
  }
`;

/** Query to get all widget configurations by type. */
export const readWidgetConfigurationsByTypeQuery = gql`
  ${widgetConfigurationFragment}

  query readWidgetConfigurations($integrationType: [String]) {
    Management {
      widgetConfigurations(widgetTypes: $integrationType) {
        ...WidgetConfigurationFragment
      }
    }
  }
`;

/** Query to get a single widget configuration by id. */
export const readWidgetConfigurationByIdQuery = gql`
  ${widgetConfigurationFragment}

  query readWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        ...WidgetConfigurationFragment
      }
    }
  }
`;

/** Mutation to update a widget configuration. */
export const updateWidgetConfigurationMutation = gql`
  ${widgetConfigurationFragment}

  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        ...WidgetConfigurationFragment
      }
    }
  }
`;

/** Mutation to create a widget configuration. */
export const createWidgetConfigurationMutation = gql`
  ${widgetConfigurationFragment}

  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        ...WidgetConfigurationFragment
      }
    }
  }
`;

/** Mutation to delete a widget configuration. */
export const deleteWidgetConfigurationMutation = gql`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`;
